const ERole = Object.freeze({
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_USER: "ROLE_USER",

    ROLE_ACC: "ROLE_ACC",
    ROLE_SALES_ADM: "ROLE_SALES_ADM",
    ROLE_PURCHASE: "ROLE_PURCHASE",
    ROLE_FINANCE: "ROLE_FINANCE",
    ROLE_MANAGER: "ROLE_MANAGER",
    ROLE_SALESMAN: "ROLE_SALESMAN",
    ROLE_INVENTORY: "ROLE_INVENTORY",
    ROLE_SPV: "ROLE_SPV",

    ROLE_AGEN: "ROLE_AGEN",
    ROLE_RSL_1: "ROLE_RSL_1",
    ROLE_RSL_2: "ROLE_RSL_2",
    ROLE_CS: "ROLE_CS",

})
const ERoleValues = [
    ERole.ROLE_ADMIN,
    ERole.ROLE_USER,

    ERole.ROLE_ACC,
    ERole.ROLE_SALES_ADM,
    ERole.ROLE_PURCHASE,
    ERole.ROLE_FINANCE,
    ERole.ROLE_MANAGER,
    ERole.ROLE_SALESMAN,
    ERole.ROLE_INVENTORY,
    ERole.ROLE_SPV,

    ERole.ROLE_AGEN,
    ERole.ROLE_RSL_1,
    ERole.ROLE_RSL_2,
    ERole.ROLE_CS,

]

// export default ERole
export { ERole as default, ERoleValues }
